export function createEnumMapper<T extends { [id: string]: T | string }, T2 = string>(
  obj: T,
  map: { [k in keyof T]: T2 }
): { (value: string): T2 } {
  const reverseMap: any = {};

  Object.keys(obj).forEach(x => {
    reverseMap[obj[x]] = map[x];
  });

  return (value: string) => {
    return reverseMap[value] as T2;
  };
}
